document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const variantsScript = form.querySelector('[data-variants-json]');
    const idInput = form.querySelector('[name="id"]');
    // every price on the page follows the selection: buy box AND the sticky bar
    const priceTargets = document.querySelectorAll('[data-product-price]');
    const addButton = form.querySelector('[data-add-button]');
    if (!variantsScript || !idInput) return;
    let variants = [];
    try { variants = JSON.parse(variantsScript.textContent); } catch (e) { return; }

    const formatMoney = (cents) => {
      const amount = Number(cents || 0) / 100;
      const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(amount);
      } catch (e) {
        return '$' + amount.toFixed(2);
      }
    };

    const radios = Array.from(form.querySelectorAll('[data-option-radio]'));
    const selectedOptions = () => {
      const groups = [...new Set(radios.map(r => r.name))];
      return groups.map(name => {
        const checked = form.querySelector(`[name="${name}"]:checked`);
        return checked ? checked.value : '';
      });
    };

    const update = () => {
      const selected = selectedOptions();
      const variant = variants.find(v => JSON.stringify(v.options) === JSON.stringify(selected));
      if (!variant) return;
      idInput.value = variant.id;
      const money = formatMoney(variant.price);
      priceTargets.forEach((el) => { el.textContent = money; });
      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
    };

    radios.forEach(r => r.addEventListener('change', update));
    update();
  });

  // "+ Add audio" reveals the second upload without cluttering the buy box
  document.querySelectorAll('[data-add-audio]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const row = document.getElementById(btn.getAttribute('aria-controls'));
      if (!row) return;
      const open = row.hasAttribute('hidden');
      if (open) { row.removeAttribute('hidden'); } else { row.setAttribute('hidden', ''); }
      btn.setAttribute('aria-expanded', String(open));
      btn.classList.toggle('is-open', open);
      if (open) {
        const input = row.querySelector('input[type=file]');
        if (input) input.focus();
      }
    });
  });
});
